// extracted by mini-css-extract-plugin
module.exports = {"step-section":"step-section__3rJ2G","title":"title__3iJjN"};